import { OperationResponse, OperationResponseFromJSON } from 'api/quote';
import { baseURL } from 'app/client';
import { createAuthInterceptor } from 'services/swagger-api/authInterceptor';

/**
 * Abandonne un devis : PUT /api/backoffice/devis/{devisId}/abandon (body vide).
 *
 * Cet endpoint n'est pas encore présent dans le client généré `QuotesApi` : on fait
 * un lien manuel. On passe par l'auth-interceptor fetch pour bénéficier de l'auth ET de
 * l'affichage automatique du toaster basé sur `OperationResponse.notification` (toaster
 * vert "Le devis a été abandonné."), comme tous les appels générés.
 *
 * ⚠️ L'échec métier revient en HTTP 200 avec `isSuccess: false` (+ `errorMessage`), pas un
 * code HTTP d'erreur : l'appelant doit tester `isSuccess`.
 */
const authFetch = createAuthInterceptor();

export async function abandonDevis(devisId: string): Promise<OperationResponse> {
  const response = await authFetch(
    `${baseURL}/api/backoffice/devis/${encodeURIComponent(devisId)}/abandon`,
    {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({})
    }
  );

  const data = await response.json();
  return OperationResponseFromJSON(data);
}
